import {useLocation, useNavigate, useParams} from 'react-router-dom';
import Button from '../../../../components/button';
import DotsLoading from '../../../../components/dotsLoading';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NoData from '../../../../components/noData';
import useGetMyStoreSubBrands from '../../../../services/hookService/getMyStoreSubBrands/useGetMyStoreSubBrands';
import {sortByStatus} from '../../../../utilities/helper/sortByStatus';
import StoreDetailHeader from '../StoreDetailHeader';
import StoreSubBrandCard from './StoreSubBrandCard';

const MyStoreSubBrands = () => {
  const navigate = useNavigate();
  const {brandId} = useParams();
  const {state} = useLocation();

  const {data, isLoading, loaderRef, isFetchingNextPage} =
    useGetMyStoreSubBrands({
      brandId: +brandId!,
    });

  if (isLoading)
    return (
      <div className="grid min-h-dvh place-content-center">
        <DotsLoading />
      </div>
    );

  return (
    <div className="relative flex flex-col w-full h-screen">
      <div>
        <CustomHeader
          isActiveRightIcon={true}
          preComponent={() => (
            <div
              className="relative flex items-center justify-center gap-2"
              onClick={() => navigate('/my-store-brands')}
            >
              <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
              <span className="font-medium">{state?.brandName ?? ''}</span>
            </div>
          )}
        />
      </div>

      <div className="flex flex-col w-full gap-3 mb-10 overflow-y-auto">
        <StoreDetailHeader logo={state?.brandLogo || ''} />
        <div className="p-4">
          <span className="text-gray-800">محصولات</span>

          {!data?.length ? (
            <div className="flex items-center justify-center mt-36">
              <NoData text="تا کنون هیچ محصولی برای این برند ثبت نشده است" />
            </div>
          ) : (
            <div className="mt-2 mb-20 space-y-3">
              {data
                ?.sort((a, b) => sortByStatus(a, b))
                ?.map(item => (
                  <StoreSubBrandCard key={item.id} item={item} />
                ))}

              {/* This div acts as a sentinel for triggering infinite scroll */}
              <div ref={loaderRef} className="mt-4 text-center">
                {isFetchingNextPage ? <DotsLoading /> : null}
              </div>
            </div>
          )}

          <Button
            onClick={() => navigate(`/create-brand/${brandId}/add-product`)}
            className="fixed left-4 right-4 bottom-6"
          >
            افزودن محصول جدید
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MyStoreSubBrands;
